import { Component, OnInit } from '@angular/core';
import { FormControlService } from '../../shared/services/form-control.service';
import { ApiService } from '../../shared/services/api.service';
import { AlertService } from '../../shared/services/alert.service';
import { InlineFormBase } from '../../shared/components/base/inline-form/inline-form.base.component';
import { Textarea } from '../../models/editors/textarea.model';

@Component({
  selector: 'swb-career-desc',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})

export class CareerDescComponent extends InlineFormBase<{ address: string }> implements OnInit {
  public url = 'career-info';
  public headerTitle = 'Doprovodný text';
  public get fieldsConfig(): Array<any> {
    return [
      new Textarea({
        key: 'content',
        label: 'Doprovodný text',
        isMultilang: true,
        wysiwyg: 'career-info'
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }

}
